import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Navtab from "./Components/Navb/Navtab";
import Hero from "./Components/Hero/Hero";
import Intrest from "./Components/Intrest/Intrest";
import Project from "./Components/Proj/Project";
import Contact from "./Components/Contact/Contact";
import Footer from "./Components/Footer/Footer";
 
function App() {
  return (
    <div>
       
      <Navtab />
      <section id="home">
        <Hero />
      </section>
      <section id="interest">
        <Intrest />
      </section>
      <section id="project">
        <Project />
      </section>
      <section id="contact">
        <Contact />
      </section>

      <Footer/>
    </div>
  );
}

export default App;
